import React, { useEffect, useState } from "react";
import "./deposit.css";
import { useForm } from "react-hook-form";
import { useDropzone } from "react-dropzone";

import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { storage } from "../../../firebase";
// import firebase from "firebase/app";
import "firebase/firestore";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import { Flip, ToastContainer, toast } from "react-toastify";
import { ArrowRight } from "lucide-react";
import ButtonLoading from "../../../components/ButtonLoading";
// import Joyride from "react-joyride";
import useAuth from "../../../hooks/useAuth";

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16,
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid #eaeaea",
  marginBottom: 8,
  marginRight: 8,
  width: "100%",
  height: "100%",
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

const img = {
  display: "block",
  width: "auto",
};

const Deposit = () => {
  const [files, setFiles] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [run, setRun] = useState(false);
  const { authenticated, setAuthenticated } = useAuth();

  const clearFiles = () => {
    setFiles([]);
    if (disabled) {
      setDisabled(false);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/*": [],
    },
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      setFiles(
        // acceptedFiles[0]
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
      console.log(files);
    },
  });
  const thumbs = files.map(
    (file) => (
      console.log(files),
      (
        <div style={thumb} key={file.name}>
          <div style={thumbInner}>
            <img
              src={file.preview}
              style={img}
              className="w-max-full h-60"
              // Revoke data uri after image is loaded
              onLoad={() => {
                URL.revokeObjectURL(file.preview);
              }}
            />
          </div>
        </div>
      )
    )
  );
  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    console.log(authenticated?.user?.joyride?.deposit, "this is deposit");
    if (authenticated?.user?.joyride?.deposit == false) {
      setRun(true);
      // setStepIndex(0);
    }
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);

  useEffect(() => {
    console.log(authenticated?.user, "this is deposit");
    if (authenticated?.user?.joyride?.deposit == false) {
      setRun(true);
      // setStepIndex(0);
    }
  }, [run]);

  const steps = [
    {
      target: ".choosePaymentMethod",
      content:
        "Choose Your payment methods, Right now easypaisa is working and we will add more options soon.",
    },
    {
      target: ".Accountinfo",
      content:
        "This is very important information, double check all the account information before submitting!!!",
    },
    {
      target: ".importantInfo",
      content:
        "This is very important information, carefully generate easypaisa transaction, double check all your information before submitting!!!",
    },
  ];

  const handleJoyrideCallback = async (data) => {
    const { status, action } = data;

    if (status === "finished") {
      console.log("Guide completed. No steps left.");
      // Add custom code here when all steps are completed
      const formData = {
        joyride: { deposit: true },
      };
      await axiosPrivate
        .put("/users/updateUser", formData, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res.data);

          setAuthenticated((prevState) => ({
            ...prevState, // Spread the previous state
            user: {
              ...prevState.user, // Spread the previous user object
              joyride: {
                ...prevState.user.joyride, // Spread the previous joyride object
                deposit: true, // Update only the dashboard property
              },
            },
          }));
          setRun(false);

          // setUserImage(null);
        })
        .catch((err) => console.log(err));
    }

    if (status === "skipped") {
      console.log("Guide skipped by the user.");
      const formData = {
        joyride: { deposit: true },
      };
      await axiosPrivate
        .put("/users/updateUser", formData, {
          withCredentials: true,
        })
        .then((res) => {
          console.log(res.data);

          setAuthenticated((prevState) => ({
            ...prevState, // Spread the previous state
            user: {
              ...prevState.user, // Spread the previous user object
              joyride: {
                ...prevState.user.joyride, // Spread the previous joyride object
                deposit: true, // Update only the dashboard property
              },
            },
          }));
          setRun(false);

          // setUserImage(null);
        })
        .catch((err) => console.log(err));
      // Add custom code for skip action
      setRun(false);
    }

    if (action === "close") {
      console.log("Guide was closed manually.");
      setRun(false);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  return (
    <div className="container bg-black p-4 rounded-xl bg-opacity-50 mx-auto ">
      <ToastContainer />
      {/* {authenticated?.user?.joyride?.deposit == false ? (
        <>
          <Joyride
            run={run}
            steps={steps}
            continuous
            disableScrollParentFix
            // stepIndex={stepIndex}
            // spotlightClicks={false}
            showProgress
            showSkipButton
            callback={handleJoyrideCallback}
            styles={{
              options: {
                zIndex: 10000,
              },
            }}
          />
          ...
        </>
      ) : (
        <></>
      )} */}
      <div className="text-lg uppercase font-bold">deposit</div>
      <small>deposit funds into your account.</small>
      <div>
        <div class="flex flex-col m-auto p-auto choosePaymentMethod">
          <h1 class="flex py-5 lg:px-20  text-white md:px-10 px-5 lg:mx-40 md:mx-20 mx-5 font-bold text-xl text-gray-800">
            Choose Payment method
          </h1>
          <div class="flex overflow-x-scroll pb-10 hide-scroll-bar">
            <div class="flex flex-nowrap lg:ml-20 md:ml-20 ml-10 ">
              <div class="inline-block px-3">
                <div class=" max-w-xs flex items-center overflow-hidden rounded-lg shadow-md border py-2 px-5 hover:shadow-xl transition-shadow duration-300 ease-in-out">
                  <p className="text-lg">Easypaisa</p>
                  <img
                    src="https://crystalpng.com/wp-content/uploads/2024/10/Easypaisa-logo.png"
                    className="w-10 h-10 ms-2 bg-white rounded"
                  />
                </div>
              </div>
              <div class="inline-block px-3">
                <div class=" max-w-xs flex items-center overflow-hidden rounded-lg shadow-md border py-2 px-5 hover:shadow-xl transition-shadow duration-300 ease-in-out">
                  <p className="text-lg">JazzCash</p>
                  <small className="bg-black p-2 rounded-xl ms-2">
                    Comming soon...
                  </small>
                  <img
                    src="https://banner2.cleanpng.com/20180327/zdw/avjcarvs7.webp"
                    className="w-14 h-10 ms-2 bg-white rounded"
                  />
                </div>
              </div>
              <div class="inline-block px-3">
                <div class=" max-w-xs flex items-center overflow-hidden rounded-lg shadow-md border py-2 px-5 hover:shadow-xl transition-shadow duration-300 ease-in-out">
                  <p className="text-lg">BankTransfer</p>
                  <small className="bg-black p-2 rounded-xl ">
                    Comming soon...
                  </small>

                  <img
                    src="https://seeklogo.com/images/B/bank-transfer-logo-291DE7CDB2-seeklogo.com.png"
                    className="w-14 h-10 ms-2 bg-white rounded"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="text-lg uppercase font-bold">Balance : </div>
        <small>Balance of funds in your account.</small>
      </div>
      <div>
        <div className="text-lg uppercase font-bold">Important Note </div>
        <small>
          Balance will be updated within 15-30 minutes, depending on the
          traffic.
        </small>
      </div>
      <div id="easypaisa" className="mt-4 ">
        <div className=" bg-black bg-opacity-80 Accountinfo p-4 rounded-xl  items-center">
          <p>Easypaisa Account Info </p>
          <div>
            <p>Account Name: WALEED AHSAN</p>
            <p>Account Number: (+92)343-3325-923</p>
          </div>
        </div>
        <div className="md:flex justify-between items-center">
          <form
            className="md:w-1/2 w-full mt-5"
            id="depositForm"
            onSubmit={handleSubmit(async (data) => {
              setDisabled(true);
              console.log(data);

              if (files[0]) {
                // await setImage(files[0]);
                console.log(files[0]);
              }
              const storageRef = await ref(
                storage,
                `images/easypaisaImages/transactions/${await files[0].name}`
              );
              const uploadTask = uploadBytesResumable(storageRef, files[0]);

              uploadTask.on(
                "state_changed",
                function (snapshot) {
                  const newPercent =
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                  // setPercent(newPercent);
                  // console.log(percent + "% done");
                },

                (error) => {
                  console.log(error);
                  toast.error("Something went wrong!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    transition: Flip,
                  });
                  setDisabled(false);
                  document.getElementById("depositForm").reset();
                },
                async () => {
                  // Complete function
                  await getDownloadURL(uploadTask.snapshot.ref).then(
                    async (downloadURL) => {
                      // await setUrl(downloadURL);
                      const dataSubmit = {
                        easypaisaName: data.easypaisaName,
                        easypaisaNumber: data.easypaisaNumber,
                        easypaisaAmount: data.easypaisaAmount,
                        easypaisaTransactionId: data.easypaisaTransactionId,
                        easypaisaScreenShotURL: downloadURL,
                      };

                      console.log(downloadURL, "url image");
                      await axiosPrivate
                        .post("/easypaisa/depositRequest", dataSubmit, {
                          withCredentials: true,
                        })
                        .then((res) => {
                          console.log(res?.data);
                          toast.success(
                            "Your Request has been generated successfully! 👌",
                            {
                              position: "top-right",
                              autoClose: 5000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                              theme: "colored",
                              transition: Flip,
                            }
                          );
                          setFiles([]);

                          setDisabled(false);
                          document.getElementById("depositForm").reset();
                        })
                        .catch((err) => {
                          console.log(err);
                          toast.error("Something went wrong!", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            transition: Flip,
                          });
                          setDisabled(false);
                          document.getElementById("depositForm").reset();
                        });
                    }
                  );
                }
              );
            })}
          >
            <div>
              <div>
                <label>From Name : </label>
                <small>Name Should be exact on Easypaisa.</small>
              </div>
              <input
                {...register("easypaisaName", {
                  required: "This field is required.",
                })}
                className={`w-full my-2 ${
                  disabled ? "bg-gray-500" : ""
                }  px-6 py-2 text-black rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5`}
                type="text"
                placeholder="EASYPAISA Name"
                disabled={disabled}
              />
            </div>
            <div>
              <div>
                <label>From Number : </label>
                <small>Number Should be exact on Easypaisa.</small>
              </div>
              <input
                {...register("easypaisaNumber", {
                  required: "This field is required.",
                })}
                className={`w-full ${
                  disabled ? "bg-gray-500" : ""
                }   my-2 px-6 py-2 text-black rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5`}
                type="text"
                placeholder="EASYPAISA Number"
                disabled={disabled}
              />
            </div>
            <div>
              <div>
                <label>Amount (PKR) : </label>
                <small>minimum Amount is 100 PKR.</small>
              </div>
              <input
                {...register("easypaisaAmount", {
                  required: "This field is required.",
                })}
                className={`w-full ${
                  disabled ? "bg-gray-500" : ""
                }   my-2 px-6 py-2 text-black rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5`}
                type="number"
                disabled={disabled}
                placeholder="EASYPAISA Number"
              />
            </div>
            <div className="my-5">
              <label>Upload ScreenShot : </label>
              <small>
                upload the screenshot of the sent payment with the transaction
                id.
              </small>
            </div>

            <div>
              {files.length == 0 ? (
                <>
                  <div
                    class={`w-full ${
                      disabled ? "bg-gray-500" : ""
                    }   my-5 relative border-2 border-gray-300 border-dashed rounded-lg p-2  `}
                    id="dropzone"
                  >
                    <div {...getRootProps({ className: "dropzone" })}>
                      <div class="text-center p-4">
                        <img
                          class="mx-auto  rounded w-12 bg-opacity-50 h-12 bg-white "
                          src="https://www.svgrepo.com/show/357902/image-upload.svg"
                          alt=""
                          style={{ color: "white" }}
                        />

                        <h3 class="mt-2 text-sm font-medium text-gray-900">
                          <label
                            for="file-upload"
                            class="relative cursor-pointer"
                          >
                            <input {...getInputProps()} required />
                            <p className="text-white text-sm">
                              Drag 'n' drop some files here, or click to select
                              files
                            </p>
                            {/* <span>Drag and drop</span>
            <span class="text-indigo-600"> or browse</span>
            <span>to upload</span> */}
                          </label>
                        </h3>
                        <p class="mt-1 text-xs text-white">
                          PNG, JPG, GIF up to 10MB
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex justify-center ">
                    <section className="container">
                      <aside style={thumbsContainer} className="">
                        {thumbs}
                      </aside>
                    </section>
                    <button
                      onClick={clearFiles}
                      className="ms-4 w-10 h-10 inline-flex items-center justify-center rounded-md border border-red-500 py-1 px-3 text-center font-medium text-red-500 hover:bg-opacity-90 "
                    >
                      X
                    </button>
                  </div>
                </>
              )}

              <div>
                <div>
                  <label>Enter Transaction Id : </label>
                </div>
                <input
                  {...register("easypaisaTransactionId", {
                    required: "This field is required.",
                  })}
                  disabled={disabled}
                  className={`w-full ${
                    disabled ? "bg-gray-500" : ""
                  }   my-2 px-6 py-2 text-black rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5`}
                  type="text"
                  placeholder="EASYPAISA Transaction Id"
                />
              </div>
              <div className="container flex justify-center items-center mt-4">
                <span>
                  <button
                    disabled={disabled}
                    className=" tracking-wide mt-3 font-semibold bg-purple-700 text-white w-full py-3 px-10 rounded-lg hover:bg-purple-900 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
                  >
                    {disabled ? (
                      <ButtonLoading />
                    ) : (
                      <>
                        <p> Submit</p> <ArrowRight />
                      </>
                    )}
                  </button>
                </span>
              </div>
            </div>
          </form>

          <img
            src="https://crystalpng.com/wp-content/uploads/2024/10/Easypaisa-logo.png"
            className="w-80 h-80 mx-4 rounded mt-4"
          />
        </div>
      </div>
    </div>
  );
};

export default Deposit;
